@if(incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (bronheffingBtl.length > 0) {
      <div formArrayName="belasting">
        @for (item of bronheffingBtl.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Rekeningnummer' : ''"
                                              class="custom-input-250"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Land' : ''"
                                                [options]="optionsLandcodes"
                                                class="custom-input-175"
                                                formControlName="landCode"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividend box 3' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="buitenlandsDividendbox3"
                                                id="buitenlandsDividendbox3"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Bronbelasting box 3' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bronbelastingOpDividendbox3"
                                                id="bronbelastingOpDividendbox3"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividend box 2' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="buitenlandsDividendbox2"
                                                id="buitenlandsDividendbox2"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Bronbelasting box 2' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bronbelastingOpDividendbox2"
                                                id="bronbelastingOpDividendbox2"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Bronbelasting toevoegen
  </snelstart-ui-button>
}
